import globalErrorHandler from "./globalErrorHandler";
import {Role} from "../types/Role";
import {axiosClient} from "./axios";
import {ApiResponse} from "./ApiResponse";

export const getRoles = () => new Promise<ApiResponse<Role[]>>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.get('/roles').then(value => resolve(value.data as ApiResponse<Role[]>))
        .catch(err => globalErrorHandler(err, reject))
})


export const createRole = (body: Role) => new Promise<void>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.post('/roles', body)
        .then(() => resolve())
        .catch(err => globalErrorHandler(err, reject))
})


export const updateRole = (id: string, body: Role) => new Promise<void>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.put('/roles/' + id, body).then(() => resolve())
        .catch(err => globalErrorHandler(err, reject))
})

export const deleteRole = (id: string,) => new Promise<void>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.delete('/roles/' + id).then(() => resolve())
        .catch(err => globalErrorHandler(err, reject))
})
